import { render, staticRenderFns } from "./StudentAppointmentsList.vue?vue&type=template&id=a8b0f4be"
import script from "./StudentAppointmentsList.vue?vue&type=script&lang=js"
export * from "./StudentAppointmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8b0f4be')) {
      api.createRecord('a8b0f4be', component.options)
    } else {
      api.reload('a8b0f4be', component.options)
    }
    module.hot.accept("./StudentAppointmentsList.vue?vue&type=template&id=a8b0f4be", function () {
      api.rerender('a8b0f4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/appointment/StudentAppointmentsList.vue"
export default component.exports